var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0107 6.23218H14.0107V3.23218",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8891 11.8891C11.1199 12.6583 10.1399 13.1821 9.073 13.3943C8.0061 13.6065 6.90023 13.4976 5.89524 13.0813C4.89025 12.6651 4.03126 11.9601 3.42692 11.0556C2.82257 10.1512 2.5 9.0878 2.5 8C2.5 6.91221 2.82257 5.84884 3.42692 4.94437C4.03126 4.0399 4.89025 3.33495 5.89524 2.91867C6.90023 2.50238 8.0061 2.39346 9.073 2.60568C10.1399 2.8179 11.1199 3.34173 11.8891 4.11091L14.0104 6.23224",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClockwise);
export default __webpack_public_path__ + "static/media/arrow_clockwise.aaad31e937adb47c59e52a02926159a3.svg";
export { ForwardRef as ReactComponent };